import {useIntl} from 'react-intl'
import useGlobalFields from './useGlobalFields'

export default function useNotifyFields({form, prefix = ''}) {
    const {formatMessage} = useIntl()

    const phonePlaceholder = formatMessage({
        defaultMessage: 'Optional',
        id: 'notify.modal.optional'
    })

    const {firstName, lastName, phone, email} = useGlobalFields({
        form,
        prefix
    })

    const fields = {
        firstName: {
            ...firstName
        },
        lastName: {
            ...lastName
        },
        email: {
            ...email
        },
        phone: {
            ...phone,
            placeholder: phonePlaceholder,
            rules: {...phone.rules.pattern, required: null}
        }
    }

    return fields
}
